/** URL déterministe de photo de profil (mock). */
export function patientPhotoUrl(uuid: string): string {
  return `https://i.pravatar.cc/150?u=${encodeURIComponent(uuid)}`;
}
